import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SNModalService } from '@web-services/modal/snModal.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Contract } from '@models/models';

@Component({
	selector: 'edit-contract-modal',
	template: require('./edit-contract-modal.component.html'),
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditContractModalComponent {
	@Input() btnDisabled = false;
	@Input() action: string;
	@Input() contractToEdit: Contract;

	constructor(
		public activeModal: NgbActiveModal,
		private modalService: SNModalService
	) {}

	onDismiss(): void {
		this.activeModal.dismiss('close Modal');
	}

	saveEditedContract(): void {
		if (this.contractToEdit && this.contractToEdit.text !== '') {
			this.modalService.setModalData({
				action: this.action,
				props: JSON.parse(JSON.stringify(this.contractToEdit))
			});
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/contract/edit-contract-modal/edit-contract-modal.component.ts